import React from "react";
import { Box, Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

import AppColor from "../../../utilities/AppColor";
import LogoIcon from "assets/icons/care-aid.png";

const styles = makeStyles((theme) => ({
  loginContainer: {
    width: "calc(100% + 30px)",
    margin: "0 10px",
  },
  paper: {
    padding: "1rem 1rem 2rem 1rem",
    borderRadius: 17,
  },
  title: {
    fontSize: 28,
    fontWeight: "bold",
    color: AppColor.blueDark,
    lineHeight: "38px",
    textAlign: "center",
    marginBottom: 32,
  },
  subTitle: {
    fontSize: 15,
    color: AppColor.blueDark,
    lineHeight: "23px",
    textAlign: "center",
    fontStyle: "italic",
  },
  margin: {
    marginTop: theme.spacing(3),
  },
  logo: {
    height: 40,
    '& img': {
      maxHeight: 40
    }
  },
  button: {
    fontSize: 15,
    fontWeight: "bold",
    borderRadius: 10,
    textTransform: "none",
    "& .MuiButton-label": {
      justifyContent: "space-between",
    },
  },
}));

const LoginContainer = ({ children, containerStyle, paperStyle }) => {
  const classes = styles();
  const { t } = useTranslation();

  return (
    <div className={classes.loginContainer} style={containerStyle}>
      <Helmet>
        <title>{t("label.login")}</title>
      </Helmet>

      <Grid container justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <Paper className={classes.paper} style={paperStyle}>
            <Grid item xs={12} sm={12} md={12}>
              <Box className={classes.logo}>
                <img src={LogoIcon}/>
              </Box>
            </Grid>
            {children}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

LoginContainer.propTypes = {
  children: PropTypes.any,
  containerStyle: PropTypes.object,
  paperStyle: PropTypes.object,
};

export default LoginContainer;
